import get from 'lodash.get';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import DepositLink from 'dibs-buyer-deposit/exports/DepositLink';
import DepositShortCopy from 'dibs-buyer-deposit/src/messages/DepositShortCopy';
import depositTracking from 'dibs-buyer-deposit/exports/depositTracking';
import DepositsAccepted from 'dibs-buyer-deposit/src/messages/DepositsAccepted';

import { PdpSharedDepositModalLoader } from '../PdpSharedModals/PdpSharedDepositModal/PdpSharedDepositModalLoader';

export class PdpSharedDepositPaymentDetailComponent extends Component {
    constructor(props) {
        super(props);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.openModal = this.openModal.bind(this);

        this.state = {
            isModalOpen: false,
        };
    }

    handleModalClose() {
        depositTracking.trackClose();
        this.setState({ isModalOpen: false });
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    render() {
        const { item, userId, relay, wrapper: Wrapper, linkClass } = this.props;
        const { isModalOpen } = this.state;
        const isDepositAvailable = get(item, 'isDepositAvailable');

        if (!userId || !isDepositAvailable) {
            return null;
        }

        return (
            <Wrapper title={<DepositsAccepted />} printHide dataTn="deposit-payment-details">
                <div>
                    <DepositShortCopy />
                </div>
                <DepositLink onClick={this.openModal} wrapperClass={linkClass} />
                <PdpSharedDepositModalLoader
                    isOpen={isModalOpen}
                    itemId={item.serviceId}
                    buyerId={userId}
                    handleClose={this.handleModalClose}
                    environment={relay.environment}
                />
            </Wrapper>
        );
    }
}

PdpSharedDepositPaymentDetailComponent.propTypes = {
    userId: PropTypes.string,
    item: PropTypes.object,
    relay: PropTypes.object,
    wrapper: PropTypes.func.isRequired,
    linkClass: PropTypes.string,
};

export const PdpSharedDepositPaymentDetail = createFragmentContainer(
    PdpSharedDepositPaymentDetailComponent,
    {
        item: graphql`
            fragment PdpSharedDepositPaymentDetail_item on Item {
                serviceId
                isDepositAvailable(buyerId: $userId)
            }
        `,
    }
);
